import { Component } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { LocationCamera } from '../../../../types';

type CellParams = ICellRendererParams<LocationCamera>;

@Component({
  selector: 'app-pan-cell-connection-type',
  imports: [MatIconModule],
  templateUrl: './cell-connection-type.component.html',
})
export class CellConnectionTypeComponent implements ICellRendererAngularComp {
  public params!: CellParams;

  agInit(params: CellParams) {
    this.params = params;
  }

  refresh(params: CellParams) {
    this.params = params;
    return true;
  }
}
